module.exports = __webpack_public_path__ + "static/img-management-f27e8c654ead6c833bfbd7206c2d40a1.jpg";